import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import api from "@/lib/api";
import AdminCard from "../AdminCard";

export const SubscribersPanel = ({ onChanged }) => {
    const [subs, setSubs] = useState([]);
    const load = () => api.get("/newsletter/subscribers").then((r) => setSubs(r.data || []));
    useEffect(() => { load(); }, []);

    const del = async (id) => {
        if (!window.confirm("Usunąć subskrybenta?")) return;
        await api.delete(`/newsletter/${id}`);
        await load(); onChanged?.();
    };

    return (
        <AdminCard>
            <h3 className="font-serif text-xl text-[#092E22] mb-1">Subskrybenci newslettera ({subs.length})</h3>
            <p className="text-xs text-gray-500 mb-5">Osoby zapisane formularzem na stronie. W kampanii wybierz grupę „Subskrybenci newslettera”.</p>
            <div className="grid md:grid-cols-2 gap-2 max-h-[600px] overflow-y-auto">
                {subs.length === 0 && <p className="text-gray-500">Brak zapisanych.</p>}
                {subs.map((s) => (
                    <div key={s.id} className="flex justify-between items-center p-3 rounded-xl bg-[#FAF8F3] border border-gray-100" data-testid={`admin-sub-${s.id}`}>
                        <div className="min-w-0">
                            <p className="text-sm text-[#092E22] truncate">{s.email}</p>
                            <p className="text-xs text-gray-500">{new Date(s.created_at).toLocaleDateString("pl-PL")}</p>
                        </div>
                        <button onClick={() => del(s.id)} className="text-red-500 hover:text-red-700" data-testid={`admin-sub-delete-${s.id}`}><Trash2 size={14} /></button>
                    </div>
                ))}
            </div>
        </AdminCard>
    );
};

export default SubscribersPanel;
